import React, { useState } from "react";
import {
  Modal,
  Button,
  Flex,
  TextInput,
  Textarea,
  ErrorMessage,
  Label,
  toast,
} from "@jsq/ds/core";
import { useInviteToUploadMutation } from "../../../graphql/supergraphHooks";
import { type DocumentUploadInviteDetails } from "../../../graphql/supergraphTypes";
import { validateEmail } from "../../../utils/email_validator";
import { clientContext } from "../../../utils/graphql_utils";
import { InviteToUploadModalProps } from "./types";

export const InviteToUploadModal: React.FC<InviteToUploadModalProps> = ({
  show = false,
  caseId,
  profileId,
  onClose,
}) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showEmailError, setShowEmailError] = useState(false);
  const [inviteToUpload, { loading: inviteLoading }] = useInviteToUploadMutation({
    context: clientContext(),
  });

  const handleSubmit = () => {
    if (!validateEmail(email.trim())) {
      setShowEmailError(true);
    } else {
      setShowEmailError(false);
      inviteToUpload({
        variables: {
          emailId: email,
          message,
          caseId,
          profileId,
        },
      })
        .then((response: unknown) => {
          toast.success("Invite sent successfully");
          onClose(response as DocumentUploadInviteDetails);
        })
        .catch(() => {
          toast.error("Invitation was not sent. Please try again.");
        });
    }
  };
  return (
    <Modal show={show} size="small">
      <Modal.Header closeButton onHide={() => onClose(null)}>
        <Modal.Title>Invite to complete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Label htmlFor="email-address-input">Email address</Label>
          <TextInput
            id="email-address-input"
            value={email}
            disabled={inviteLoading}
            onSetValue={(value) => {
              setEmail(value);
              setShowEmailError(false);
            }}
            isFullWidth
          />
          {showEmailError && <ErrorMessage>Please enter a valid email address</ErrorMessage>}
        </div>
        <div>
          <Label htmlFor="message-input">Message</Label>
          <Textarea
            id="message-input"
            value={message}
            onSetValue={setMessage}
            isFullWidth
            size="small"
            disabled={inviteLoading}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex flexDirection="row" gap="10px" justifyContent="flex-end">
          <Button variant="neutral" onClick={() => onClose(null)} disabled={inviteLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            data-testid="submit-button"
            onClick={handleSubmit}
            disabled={inviteLoading}
            isLoading={inviteLoading}
          >
            Submit
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
